module.exports = __webpack_public_path__ + "img/scroll-6.29ad0379.jpg";